import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Inbox as InboxIcon, Users, Target } from "lucide-react";
import Inbox from "../Inbox";
import Leads from "../Leads";
import Opportunities from "../Opportunities";

const TABS = [
  { id: "inbox", label: "AI Inbox", icon: InboxIcon, comp: Inbox, hint: "Unified DMs · WhatsApp · Comments" },
  { id: "leads", label: "Leads", icon: Users, comp: Leads, hint: "Pipeline & lead intelligence" },
  { id: "opportunities", label: "Opportunities", icon: Target, comp: Opportunities, hint: "AI-found money on the table" },
];

export default function Capture() {
  const [params, setParams] = useSearchParams();
  const initial = params.get("tab") || "inbox";
  const [tab, setTab] = useState(initial);
  const Active = TABS.find(t => t.id === tab)?.comp || Inbox;
  const meta = TABS.find(t => t.id === tab);

  return (
    <div data-testid="capture-page">
      <SectionHeader title="Capture" subtitle="Where conversations become qualified pipeline" tabs={TABS} active={tab}
        onChange={(id) => { setTab(id); setParams({ tab: id }); }} hint={meta?.hint} />
      <Active />
    </div>
  );
}

export function SectionHeader({ title, subtitle, tabs, active, onChange, hint }) {
  return (
    <div className="bg-white border-b border-line sticky top-0 z-20" data-testid={`section-header-${title.toLowerCase()}`}>
      <div className="px-4 sm:px-6 lg:px-10 pt-6 pb-3 max-w-[1600px] mx-auto">
        <div className="flex items-end justify-between gap-3 flex-wrap">
          <div>
            <h1 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight text-ink">{title}</h1>
            <p className="text-sm text-meta mt-0.5">{subtitle}</p>
          </div>
          {hint && <p className="text-xs text-meta-soft italic hidden sm:block">{hint}</p>}
        </div>
        <div className="mt-4 inline-flex rounded-full bg-zinc-100 p-1 overflow-x-auto scrollbar-thin">
          {tabs.map(t => {
            const Icon = t.icon;
            const isActive = t.id === active;
            return (
              <button key={t.id} onClick={() => onChange(t.id)} data-testid={`tab-${t.id}`}
                className={`px-4 py-1.5 text-xs font-semibold rounded-full transition focus-ring whitespace-nowrap inline-flex items-center gap-1.5 ${isActive ? "ashra-gradient-bg text-white shadow-sm" : "text-meta hover:text-ink"}`}>
                <Icon className="h-3 w-3" /> {t.label}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
